import(/* webpackMode: "eager", webpackExports: ["TermsOfServicePageContent"] */ "/vercel/path0/src/components/inbound-gpt/legal-pages.tsx");
